import { FormScreens } from "@/features/developer/form-anatomy/FormScreens";
import type { FormScreen } from "@/features/developer/form-anatomy/variables";
import { createFileRoute, redirect } from "@tanstack/react-router";

const SCREENS: FormScreen[] = ["cover", "instructions", "question", "block"];

export const Route = createFileRoute("/_app/design/forms/pages/$screen")({
    beforeLoad: ({ params }) => {
        if (!SCREENS.includes(params.screen as FormScreen)) {
            throw redirect({ to: "/design/forms/pages/$screen", params: { screen: "cover" } });
        }
    },
    component: FormScreenPage,
});

function FormScreenPage() {
    const { screen } = Route.useParams();
    // Keyed so each screen starts from its own defaults.
    return <FormScreens key={screen} screen={screen as FormScreen} />;
}
